<template>
  <div class="container-root">
    <div class="loader" v-if="isLoading"></div>
    <div v-else>
      <div class="header-group">
        <h2 style="margin:0px;font-weight:bold;">MY DETAILS</h2>
      </div>
      <div style="margin-top:25px;">
        <StaffDetails
          :profile="profile"
          :id="profile.id"
          :banks="banks"
        ></StaffDetails>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '../digilib_web/core/digitify';
import StaffDetails from './staff_details';

export default {
  props: {
    profile: Object
  },
  mounted() {
    // get the list of the banks then
    http.get('banks').then(json => {
      this.banks = json.data;
      this.isLoading = false;
    });
  },
  data() {
    return {
      notif: null,
      isLoading: true,
      banks: []
    };
  },
  components: {
    StaffDetails
  }
};
</script>

<style scoped>
.header-group {
  display: flex;
  justify-content: space-between;
}
</style>
